import * as React from "react";
import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        // Hairline border, no offset ring — the focus glow grows in instead of snapping.
        "flex h-10 w-full rounded-md border border-border bg-background px-3 py-2 text-sm transition-shadow duration-200 ease-out",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none",
        "focus-visible:border-primary/45",
        "focus-visible:shadow-[0_0_0_4px_color-mix(in_oklch,var(--color-primary)_14%,transparent)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
